import { useTranslate } from "@similarweb/i18n-provider";
import { Add } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { ComboboxWithSelectedChips } from "app/pages/digital-marketing/keywords-campaigns/shared/components";
import type { ComboboxWithChipsProps } from "app/pages/digital-marketing/keywords-campaigns/shared/components";

type AddTagsComboboxProps = Omit<ComboboxWithChipsProps, "triggerIconName" | "placeholder" | "children"> & {
    showCreateOption: boolean;
    options: string[];
    onOptionClick: (tag: string) => void;
};

const AddTagsCombobox = ({
    isOpen,
    onOpenChange,
    selectedChips,
    onCloseChip,
    searchValue,
    onSearchValueChange,
    showCreateOption,
    options,
    onOptionClick,
}: AddTagsComboboxProps) => {
    const { translate } = useTranslate();
    return (
        <ComboboxWithSelectedChips
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            triggerIconName="diagonal-tag"
            placeholder={translate("rankTracker.editTags.modal.triggerPlaceholder")}
            selectedChips={selectedChips}
            onCloseChip={onCloseChip}
            searchValue={searchValue}
            onSearchValueChange={onSearchValueChange}
        >
            <Combobox.Content emptyState={translate("dropdown.no.results")}>
                {showCreateOption ? (
                    <Combobox.Option
                        key="create-new-tag"
                        onClick={() => onOptionClick(searchValue.trim())}
                    >
                        <Flex alignItems="center" gap="8px">
                            <Add
                                size="sm"
                                color={colorsPalettes.carbon[200]}
                            />
                            {translate("rankTracker.editTags.modal.createTagOption", {
                                name: searchValue.trim(),
                            })}
                        </Flex>
                    </Combobox.Option>
                ) : null}
                {options.map((tag) => (
                    <Combobox.Option
                        key={tag}
                        onClick={() => onOptionClick(tag)}
                    >
                        <Combobox.OptionLabel>{tag}</Combobox.OptionLabel>
                    </Combobox.Option>
                ))}
            </Combobox.Content>
        </ComboboxWithSelectedChips>
    );
};

export default AddTagsCombobox;
